"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollectionMultiColorIcon20 = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const CollectionMultiColorIcon20 = _ref => {
  let {
    color,
    primaryBackgroundColor,
    secondaryBackgroundColor,
    ...rest
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    fill: "none",
    viewBox: "0 0 20 20"
  }, rest), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M14 4.4H8.21A1.6 1.6 0 0 0 6.61 6v5.79a1.6 1.6 0 0 0 1.6 1.6H14a1.6 1.6 0 0 0 1.6-1.6V6A1.6 1.6 0 0 0 14 4.4M14 3H8.21a3 3 0 0 0-3 3v5.79a3 3 0 0 0 3 3H14a3 3 0 0 0 3-3V6a3 3 0 0 0-3-3",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: primaryBackgroundColor,
    d: "M6 5.21h5.79a3 3 0 0 1 3 3V14a3 3 0 0 1-3 3H5.774A2.774 2.774 0 0 1 3 14.226V8.21a3 3 0 0 1 3-3"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: secondaryBackgroundColor,
    d: "M10.8 5.92H7v6.736a.3.3 0 0 0 .49.232l1.41-1.154 1.41 1.154a.3.3 0 0 0 .49-.232z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M11.79 6.61H6a1.6 1.6 0 0 0-1.6 1.6v6.016c0 .759.615 1.374 1.374 1.374h6.016a1.6 1.6 0 0 0 1.6-1.6V8.21a1.6 1.6 0 0 0-1.6-1.6m0-1.4H6a3 3 0 0 0-3 3v6.016A2.774 2.774 0 0 0 5.774 17h6.016a3 3 0 0 0 3-3V8.21a3 3 0 0 0-3-3",
    clipRule: "evenodd"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M6.3 5.92a.7.7 0 0 1 .7-.7h3.8a.7.7 0 0 1 .7.7v6.736a1 1 0 0 1-1.633.774l-.967-.791-.967.79a1 1 0 0 1-1.633-.773zm1.4.7v5.192l.757-.62a.7.7 0 0 1 .886 0l.757.62V6.62z",
    clipRule: "evenodd"
  }));
};
exports.CollectionMultiColorIcon20 = CollectionMultiColorIcon20;
//# sourceMappingURL=CollectionMultiColorIcon20.js.map